import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export function timeAgo(val) {
  if (!val) return "—";
  let date;
  if (Array.isArray(val)) {
    const [y, mo, d, h = 0, mi = 0, s = 0] = val;
    date = new Date(y, mo - 1, d, h, mi, s);
  } else {
    date = new Date(val);
  }
  if (isNaN(date.getTime())) return "—";
  const diff = Math.floor((Date.now() - date.getTime()) / 1000);
  if (diff < 60) return "Just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return date.toLocaleDateString();
}

export function capitalizeName(name) {
  if (!name) return name;
  return String(name)
    .trim()
    .split(/[\s-]+/)
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : ""))
    .join(" ");
}

export function formatLabel(val) {
  if (!val) return "—";
  return String(val)
    .replace(/_/g, " ")
    .trim()
    .split(/\s+/)
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : ""))
    .join(" ");
}

export const getApiOrigin = () => {
  const envUrl = process.env.REACT_APP_BASE_URL || process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";
  return String(envUrl).trim().replace(/^["']+|["']+$/g, "").replace(/\/$/, "").replace(/\/api\/?$/, "");
};

export const fixPhotoUrl = (url) => {
  if (!url) return null;
  let trimmed = String(url).trim().replace(/^["']+|["']+$/g, "");
  if (!trimmed || trimmed === "null" || trimmed === "undefined") return null;

  const isLocalClient =
    typeof window !== "undefined" &&
    (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

  const apiOrigin = getApiOrigin();

  // 1. If running locally on localhost / 127.0.0.1:
  if (isLocalClient) {
    if (trimmed.startsWith("http://localhost:8072") || trimmed.startsWith("http://127.0.0.1:8072") ||
        trimmed.startsWith("http://localhost:8080") || trimmed.startsWith("http://127.0.0.1:8080")) {
      return trimmed;
    }
    // If it's an ngrok URL pointing to /uploads/..., on localhost serve it straight from apiOrigin
    if (trimmed.includes("ngrok") && trimmed.includes("/uploads/")) {
      const pathPart = trimmed.substring(trimmed.indexOf("/uploads/"));
      const cleanPath = pathPart.split("?")[0];
      return `${apiOrigin}${cleanPath}`;
    }
    // Relative paths
    if (trimmed.startsWith("/")) {
      return `${apiOrigin}${trimmed}`;
    }
    if (!trimmed.startsWith("http://") && !trimmed.startsWith("https://")) {
      return `${apiOrigin}/${trimmed}`;
    }
    return trimmed;
  }

  // 2. If running remotely or non-localhost (production):
  if (/^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?/.test(trimmed)) {
    trimmed = trimmed.replace(/^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?/, apiOrigin);
  } else if (!trimmed.startsWith("http://") && !trimmed.startsWith("https://")) {
    if (trimmed.startsWith("/")) {
      trimmed = `${apiOrigin}${trimmed}`;
    } else {
      trimmed = `${apiOrigin}/${trimmed}`;
    }
  }

  // If the target host is an ngrok tunnel, append ngrok-skip-browser-warning query param
  if (trimmed.includes("ngrok") && !trimmed.includes("ngrok-skip-browser-warning")) {
    const separator = trimmed.includes("?") ? "&" : "?";
    trimmed = `${trimmed}${separator}ngrok-skip-browser-warning=69420`;
  }

  return trimmed;
};

